import { createAsyncThunk } from "@reduxjs/toolkit";

import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_ALL_CONVERSATION_SESSIONS,
  API_GET_CONVERSATION_ANALYSIS,
  API_GET_CONVERSATION_BY_FILTER,
  API_GET_CONVERSATION_BY_SESSION,
} from "../../Apis/ApiEndPoints";
import {
  IConversationAnalysisResponse,
  IConversationFilters,
  IGetConversationAnalysisPayload,
  IGetConversationAnalysisResponse,
  IGetConversationByFilterResponse,
  IGetConversationBySessionResponse,
} from "../../models/admin/conversationAnalysis/conversationAnalysis";

export const getAllConversationSessions = createAsyncThunk(
  "all/conversationSessions",
  async (_, { dispatch }) => {
    const response: IConversationAnalysisResponse = await CustomAction(
      Api.get(`${API_GET_ALL_CONVERSATION_SESSIONS}/getAll`),
      dispatch,
      "all/conversationSessions"
    );
    return response;
  }
);

export const getConversationAnalysis = createAsyncThunk(
  "all/conversationAnalysis",
  async (conversations: IGetConversationAnalysisPayload, { dispatch }) => {
    const response: IGetConversationAnalysisResponse = await CustomAction(
      Api.post(API_GET_CONVERSATION_ANALYSIS, conversations),
      dispatch,
      "all/conversationAnalysis"
    );
    return response;
  }
);

export const getConversationBySession = createAsyncThunk(
  "session/conversation",
  async (sessionId: string, { dispatch }) => {
    const response: IGetConversationBySessionResponse = await CustomAction(
      Api.get(`${API_GET_CONVERSATION_BY_SESSION}?sessionId=${sessionId}`),
      dispatch,
      "session/conversation"
    );
    return response;
  }
);

export const getConversationByFilter = createAsyncThunk(
  "filters/conversationAnalysis",
  async (requestParams: IConversationFilters, { dispatch }) => {
    let apiUrl = `${API_GET_CONVERSATION_BY_FILTER}?`;
    if (requestParams.fromDate) {
      apiUrl += `fromDate=${requestParams.fromDate}&`;
    }
    if (requestParams.toDate) {
      apiUrl += `toDate=${requestParams.toDate}&`;
    }

    apiUrl = apiUrl.endsWith("&") ? apiUrl.slice(0, -1) : apiUrl;

    const response: IGetConversationByFilterResponse = await CustomAction(
      Api.get(apiUrl),
      dispatch,
      "filters/conversationAnalysis"
    );
    return response;
  }
);
